import { ACTIONS } from "./actions";
import { IDP_ACTIONS } from "../../utils/enums";




const initialState = {
  showModal: false,
  idpData: [],
  idpAction: "",
  defineIdpOidc: {},
  samlData: {},
  idpServerData: {},
  idpDefined: false,
  error: null,
  idpDeleted: false,
  showSpinner: false,
  accountUpdated: false
};

const reducer = (state = initialState, action) => {
  const { type, payload, error, overlay } = action;

  if (error) {
    // @TODO : Handle errors
  }

  switch (type) {
    case ACTIONS.SHOW_MODAL:
      return {
        ...state,
        showModal: true,
        idpAction: payload.idpAction,
        idpData: payload,
        idpServerData: {},
        samlData: {},
        idpDefined: false,
        error: null,
        idpDeleted: false
      };
    case ACTIONS.HIDE_MODAL:
      return {
        ...state,
        showModal: false,
        idpDeleted: false,
        error: null
      };
    case ACTIONS.DEFINE_IDP_OIDC:
      return {
        ...state,
        idpServerData: payload,
        idpAction: IDP_ACTIONS.VIEW,
        idpDefined: true,
        error: null,
        idpDeleted: false
      };
    case ACTIONS.UPLOAD_SAML:
      return {
        ...state,
        samlData: payload,
        error: null,
        idpDeleted: false,
        showSpinner: false
      };
    case ACTIONS.GET_IDP:
      return {
        ...state,
        idpServerData: payload,
        showModal: true,
        idpAction: overlay.idpAction,
        idpData: overlay,
        error: null,
        idpDefined: false,
        idpDeleted: false
      };
    case ACTIONS.DEFINE_IDP_SAML:
      return {
        ...state,
        idpServerData: payload,
        idpAction: IDP_ACTIONS.VIEW,
        idpDefined: true,
        error: null,
        idpDeleted: false
      };
    case ACTIONS.SET_ERROR:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.DELETE_IDP:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.IS_IDP_DELETED:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.SHOW_SPINNER:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.UPDATE_ACCOUNT:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.IS_ACCOUNT_UPDATED:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export default reducer;
